import styled from 'styled-components'
import { Dialog } from '@material-ui/core'
import L from '../../L'

const StyledRadioCard = styled.div`
border: ${props => props.theme.globals.borderDark};
border-radius: ${props => props.theme.globals.borderRadiusSmall}px;
transition: ${props => props.theme.mixins.transition(['border-color'])};
${props =>
  props.checked
    ? `
  border-color: ${props.theme.palette.border.primary} !important;
`
    : ''}
${props => (props.disabled ? `pointer-events: none;` : '')}
${props =>
  !props.disabled
    ? `
  &:hover {
    border-color: #FB98CB;
  }
`
    : ''}
`

const RadioCardInner = styled.div`
  border: 2px solid transparent;
  border-radius: ${props => props.theme.globals.borderRadiusSmall - 1}px;
  transition: ${props => props.theme.mixins.transition(['border-color', 'opacity'])};
  opacity: ${props => (props.disabled && !props.checked ? 0.3 : 1)};
  ${props =>
    props.checked
      ? `
    border-color: ${props.theme.palette.border.primary} !important;
  `
      : ''}
  ${props =>
    !props.disabled
      ? `
    &:hover {
      border-color: #FB98CB;
    }
  `
      : ''}
`

const CardHead = styled(L).attrs({
  bgColor: 'secondaryDark',
  textAlign: 'center',
  pY: 1,
  pX: 1,
  display: 'grid',
  flow: 'column',
  ai: 'center',
  jc: 'center',
  gap: 1,
})`
  border-top-left-radius: ${props => props.theme.globals.borderRadius - 1}px;
  border-top-right-radius: ${props => props.theme.globals.borderRadius - 1}px;
`

const TabHeader = styled.div`
  box-shadow: ${props => props.theme.globals.boxShadowSmaller};
`

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    overflow-y: scroll;
    max-height: calc(100vh - 40px);
  }
`

const Fade = styled.div`
  transition: ${props => props.theme.globals.transition};
`

const RadioCardImg = styled(L).attrs({
  display: 'grid',
  ai: 'center',
  jc: 'center',
  height: { xx: '35px', lg: '50px' },
  width: { xx: '35px', lg: '50px' },
})`
  & svg {
    ${props =>
      props.theme.mixins.mq(
        `
      max-height: 30px;
      max-width: 30px;
    `,
        'xx',
        'lg',
      )}
  }
`

const ConfigControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px;
  margin-top: 0px;
  gap: 10px;
`

const configuratorStyles = theme => ({
  closeButton: {
    right: theme.spacing(2),
    cursor: 'pointer',
    ...theme.mixins.absoluteYCenter,
  },
  launchCard: {
    border: theme.globals.border,
    borderRadius: theme.globals.borderRadius,
    maxWidth: 350,
    width: '100%',
    height: '100%',
  },
})

export {
  CardHead,
  RadioCardInner,
  StyledRadioCard,
  TabHeader,
  StyledDialog,
  Fade,
  RadioCardImg,
  ConfigControlsContainer,
  configuratorStyles,
}
